import React from 'react';
import { Link } from 'react-router-dom';

import { RETURNS_HOME } from '../helpers/routes';

// Hardcoded common solutions links matching legacy deviceController commonSolutions list
const COMMON_SOLUTIONS = [
  {
    iconClass: 'icon-devices-blue',
    name: 'Add or Manage Devices',
    href: 'https://www.xfinity.com/buy/plan/addon/equipment',
    external: true,
  },
  {
    iconClass: 'icon-box-in-blue',
    name: 'Return a Device',
    to: RETURNS_HOME,
    external: false,
  },
  {
    iconClass: 'icon-outage-blue',
    name: 'Status Center',
    href: 'https://www.xfinity.com/support/status',
    external: true,
  },
  {
    iconClass: 'icon-help-support-blue',
    name: 'Help and Support',
    href: 'https://www.xfinity.com/support',
    external: true,
  },
  {
    iconClass: 'icon-data-use',
    name: 'View Data Usage',
    href: '#usage',
    external: false,
  },
];

const renderSvgIcon = iconClass => (
  <span className={`svg-icon ${iconClass}`} aria-hidden="true" />
);

const CommonSolutions = () => (
  <div className="common-solutions" aria-label="Common Solutions">
    <h2 className="common-solutions__title">Common Solutions</h2>

    <div className="card-group card-group--flex-vertical-at-768">
      {COMMON_SOLUTIONS.map(({

        iconClass,
        name,
        href,
        to,
        external,
      }) => {
        const linkBody = (
          <>
            <div className="card__media">
              {renderSvgIcon(iconClass)}
            </div>
            <div className="card__content">
              <span className="link">{name}</span>
            </div>
          </>
        );

        return (
          <div className="card-group__item" key={name}>
            {to ? (
              <Link className="card card--has-media common-solutions__link" to={to}>
                {linkBody}
              </Link>
            ) : (
              <a
                className="card card--has-media common-solutions__link"
                href={href}
                rel={external ? 'noopener noreferrer' : undefined}
                target={external ? '_blank' : undefined}
              >
                {linkBody}
              </a>
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default CommonSolutions;
